export default {
  pageTitle: 'Games - Thanx Merchant',
  header: {
    title: 'Games',
    poweredBy: 'powered by',
  },
  disabled: {
    title: 'Bring games into your loyalty experience',
    description:
      'Engage your customers in a fun, interactive way with gamification. Create excitement, boost participation, and reward customers through digital games that integrate seamlessly into your app.',
    features: {
      pickGame: {
        title: 'Pick a game',
      },
      customize: {
        title: 'Customize the game to match your brand',
      },
      embed: {
        title: 'Embed the game directly in your Thanx-managed app',
      },
    },
    cta: {
      title: 'Add games to your app',
      description:
        'Interested in offering games? Contact us to enable Brame integration or reach out if you have any questions.',
      learnMore: 'Learn how to set up games',
      contact: 'Contact us',
    },
  },
  enabled: {
    title: 'Games Management',
    description: 'Configure and manage your gamification features.',
    tabs: {
      collection: 'Collection',
      activity: 'Activity',
    },
    collection: {
      title: 'Game collection',
      description:
        'View all games created in Brame that have been added to Thanx. These games are available to feature in your app and engage customers through play.',
      addGameButton: 'Add a new game',
      error: 'Error loading games. Please try again.',
      gameCard: {
        openMenu: 'Open Menu',
        addToHomepage: 'Add to homepage',
        viewOnHomepage: 'View on homepage',
      },
    },
    notice: {
      title: 'Set Up Your Game in Brame and Connect It to Thanx',
      description:
        "Create and configure your game directly in Brame's dashboard, then return here to link it to your app.",
      linkText: "Go to Brame's dashboard",
      copy: 'Copy',
      config_copied_to_clipboard: 'Configuration copied to clipboard',
      config_details: 'Brame configuration details',
    },
    empty: {
      message: 'No games added yet',
    },
    activity: {
      title: 'Activity',
      comingSoon: 'Game activity content coming soon...',
    },
  },
  addForm: {
    header: {
      title: 'Game collection',
      editTitle: 'Edit Game',
      exitButton: 'Exit without saving',
      saveButton: 'Save to game collection',
    },
    content: {
      title: 'Game',
    },
    fields: {
      gameName: 'Game name',
      brameGameUrl: 'Brame game URL',
      brameGameUrlExample:
        'Example: https://campaigns.brame.io/12345678-1234-1234-1234-123456789abc/87654321-4321-4321-4321-cba987654321/',
    },
    validation: {
      gameNameRequired: 'Game name is required.',
      brameGameUrlRequired: 'Brame game URL is required.',
      invalidUrl: 'Please enter a valid URL',
      invalidBrameCampaignUrl:
        'Must be a valid Brame campaign URL (https://campaigns.brame.io/...).',
    },
    errors: {
      submit: 'An error occurred while saving the game. Please try again.',
    },
  },
  deleteModal: {
    title: 'Delete Game',
    description:
      'Are you sure you want to delete "%{gameName}"? This action cannot be undone.',
    buttons: {
      cancel: 'Cancel',
      delete: 'Delete',
    },
  },
}
